
import React from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import { MDXRenderer } from "gatsby-plugin-mdx"
import SEO from 'components/SEO'
import { css} from '@emotion/core'
import Container from 'components/Container'
import Layout from '../components/Layout'
//import  { fonts } from '../lib/typography'
import Share from '../components/Share'
import config from '../../config/website'
import Link from '../components/Link'
//import { bpMaxSM } from '../lib/breakpoints'
import { useTheme } from 'components/Theming'


export default function Post({
  data: { site, mdx },
  pageContext: { next, prev },
}) {
  const title = mdx.frontmatter.title
  const banner = mdx.frontmatter.banner
  //const thick=fonts.bold;
  const theme =useTheme()


  return (
    <Layout site={site} frontmatter={mdx.frontmatter}>
      <SEO frontmatter={mdx.frontmatter} isBlogPost />


        <Container 
          css= {css`
          display:flex;
          flex-direction:column;
          paddingBottom:30px;
         
            @media(max-width:800px){
              padding:0 10px;
              margin:0;
            }
            `}
        >

        {banner !==null && (
           <div>
            <Img role="banner" css={css`
              objectFit:cover;
              objectPosition: 0% 20%;
              max-height: 450px;
             width:100%;
             
            `
             
            }
              fluid={banner.childImageSharp.fluid}
              alt={site.siteMetadata.keywords.join(', ')}
            />
          </div>
        )}
      
        
{ typeof window !=="undefined" && window.location.pathname==="/isabel-antonio"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:28px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
        
         :hover{
           color:${theme.colors.antonio}
         }
        `} to="/antonio-isabel">MEHR FOTOS
        
       </Link></div>
        :null
        }
    { typeof window !=="undefined" && window.location.pathname==="/moga-zirden"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       
        font-family:'Roboto';
        letter-spacing:0.11rem;
         margin-top:20px;
         font-size:.8rem;
         text-align:right;
          cursor:pointer;
         color:'text'
          :hover{
            color:${theme.colors.mora}
          }
        `} to="/mogazirden">MEHR FOTOS 
        
       </Link></div>
        :null
        }

{ typeof window !=="undefined" && window.location.pathname==="/mareike-knevels"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
        
         :hover{
           color:${theme.colors.knevels}
         }
        `} to="/pantarhein1">RISOGRAPHIEN
        
       </Link>
       <Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:${theme.colors.obscura}
        }
        `} to="/knevelsillustrationen"> &nbsp;| ILLUSTRATIONEN 
        
       </Link>
       </div>
        :null
        }
  { typeof window !=="undefined" && window.location.pathname==="/knevelsillustrationen"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
        
         :hover{
           color:${theme.colors.knevels}
         }
        `} to="/pantarhein1">MEHR FOTOS 
        
       </Link></div>
        :null
        }

        { typeof window !=="undefined" && window.location.pathname==="/bacchanale"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
           color:${theme.colors.green}
         }
        `} to="/bacchanale">MEHR FOTOS 
        
       </Link></div>
        :null
        }
        
        { typeof window !=="undefined" && window.location.pathname==="/evelyn-sattler"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
           color:${theme.colors.sattler}
         }
        `} to="/sattler">MEHR FOTOS 
        
       </Link></div>
        :null
        }
   { typeof window !=="undefined" && window.location.pathname==="/verluste"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
           color:${theme.colors.verluste}
         }
        `} to="/verluste"> 
        
       </Link></div>
        :null
        }

{ typeof window !=="undefined" && window.location.pathname==="/juedischer-alltag"?
        <div css={css`
        display:flex;
        justify-content:flex-start;
        width:100%;
        flex-direction:column;

        `}>
         
          <div css={css`
            display:flex;
            flex-direction:column;

          `}>
            <div css={css`
        display:flex;
        flex-direction:column;
       `}>
       <div css={css`
        display:flex;   
 
        flex-wrap:wrap;
        @media(max-width:550px){
          flex-direction:column;
        }
       `}>
      
       <div css={css`
        width:50%;
        margin-bottom:10px;
       `}>
       <span style={{display:'block',fontWeight:400,textAlign:'left',fontSize:'.6rem',marginTop:'8px'}}>    Foto: ©Sonia A. Gallardo &amp; Evgeniya Kartashova</span>
       </div>
       <div css={css`
        width:50%;
       `}>
       <span style={{display:'block',fontWeight:400,textAlign:'left',fontSize:'.6rem',marginTop:'8px'}}>    Foto Duo Segótal: ©Taisiia Chernyshova</span>
       </div>
       </div>
       </div>
            <div>
          <Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        margin-right:29px;
        font-size:.8rem;
        text-align:left;
         cursor:pointer;
         font-weight:400;
         :hover{
           color:${theme.colors.alltag}
         }
        `} to="/jalltag">&rarr; Fotos der Ausstellung 
        
       </Link>
       </div>
       <div>
       <Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        margin-right:29px;
        font-size:.8rem;
        text-align:left;
        font-weight:400;
         cursor:pointer;
         :hover{
           color:${theme.colors.alltag}
         }
        `} to="/segotal"> &rarr; Fotos der Vernissage 
        
       </Link>
       </div>
       </div>
       
       </div>
       
        :null
        }


        { typeof window !=="undefined" && window.location.pathname==="/ausstellung"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
           color:${theme.colors.pink}
         }
        `} to="/bacchanale">MEHR FOTOS 
        
       </Link>
       <Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:${theme.colors.obscura}
        }
        `} to="/markt1filme"> &nbsp;/ VIDEO 
        
       </Link>
       </div>
        :null
        }
        { typeof window !=="undefined" && window.location.pathname==="/filme"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
           color:${theme.colors.pink}
         }
        `} to="/markt1filme">VIDEOS
        
       </Link></div>
        :null
        }
      { typeof window !=="undefined" && window.location.pathname==="/fotos-weltenfrauen"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
           color:${theme.colors.welten}
         }
        `} to="/weltenfrauen">&rarr; MEHR FOTOS
        
       </Link>
       <Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:${theme.colors.welten}
        }
        `} to="/markt1filme">&nbsp; &rarr; VIDEO 
        
       </Link>
       
       </div>
        :null
        }
          { typeof window !=="undefined" && window.location.pathname==="/camera_obscura"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:${theme.colors.obscura}
        }
        `} to="/cameraobscura">MEHR FOTOS 
        
       </Link>
       <Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:${theme.colors.obscura}
        }
        `} to="/markt1filme"> &nbsp;/ VIDEO 
        
       </Link>
       </div>
        :null
        }  
        
         { typeof window !=="undefined" && window.location.pathname==="/urbansketcher"?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:${theme.colors.lila}
        }
        `} to="/sketcher">MEHR ZEICHNUNGEN 
        
       </Link></div>
        :null
        }  
        

        { typeof window !=="undefined" && window.location.pathname==="/buga2029" ?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:${theme.colors.lila}
        }
        `} to="/minimalbehausung"> &rarr; MEHR MODELLE 
        
       </Link>
       &nbsp; &nbsp; &nbsp;
       <Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:${theme.colors.lila}
        }
        `} to="/markt1filme"> &rarr; VIDEOS 
        
       </Link>
       
       </div>
        :null
        }  
         { typeof window !=="undefined" && window.location.pathname==="/jkreiensiek" ?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}><Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:green;
        }
        `} to="/heinrichlee"> &rarr; MALEREI
        
       </Link>
       &nbsp; &nbsp; &nbsp;
       <Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:green;
        }
        `} to="/bauminstall"> &rarr; BAUM-INSTALLATION
        
       </Link>
       &nbsp; &nbsp; &nbsp;
      
       
       
       </div>
        :null
        }
      { typeof window !=="undefined" && window.location.pathname==="/lepidoptera" ?
        <div css={css`
        display:flex;
        justify-content:flex-end;

        `}>
       <Link css={css`
       font-family:'Roboto';
       letter-spacing:0.11rem;
        margin-top:8px;
        font-size:.8rem;
        text-align:right;
         cursor:pointer;
         :hover{
          color:green;
        }
        `} to="/benjamin-may"> &rarr; mehr Fotos
        
       </Link>
       &nbsp; &nbsp; &nbsp;
      
       
       
       </div>
        :null
        }
        <br />
          <h1
            // css={css`
            //   text-align: left;
            //   margin-top: 10px;
            //   font-family:'Roboto Slab';
            //   letter-spacing: .15rem;
            //   font-weight:400;
            
            // `}
          >
            {title.toUpperCase()}
          </h1>


          <div role="main" css={css`
             padding:0;
             role="main"
            }


            `}>
          <MDXRenderer>{mdx.body}</MDXRenderer>
          </div>

        </Container>
       
      <Container noVerticalPadding>
        <Share
          url={`${config.siteUrl}/${mdx.frontmatter.slug}/`}
          title={title}
          twitterHandle={config.twitterHandle}
        />
        <br />
      </Container>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($id: String!) {
    site {
      ...site
    }
    mdx(fields: { id: { eq: $id } }) {
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        author
        description
        banner {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
        slug
        keywords
      }
      body
    }
  }
`
